import { Box, Stack, Text } from '@chakra-ui/react';
import { memo } from 'react';
import { Link } from 'react-router-dom';

import { Logo } from '../Logo';

export const Footer = memo(() => {
  return (
    <Box w="full" px={{ base: '4', lg: '10' }} bgColor="bg.default" zIndex="docked">
      <Stack
        as="footer"
        role="contentinfo"
        position="relative"
        w="full"
        direction="row"
        wrap="wrap"
        align="center"
        justify={{ base: 'center', md: 'space-between' }}
        spacing={4}
        py={8}
        borderTopWidth="1px"
        borderTopColor="border.default"
      >
        <Stack direction="row" align="center" spacing="8">
          <Link to="/">
            <Logo />
          </Link>
        </Stack>
        <Text fontSize="sm">© Pelicargo Inc. | All rights reserved.</Text>
      </Stack>
    </Box>
  );
});
